export const contactsMap = [
    {
        title: 'TOUR LEADER (referenti in aeroporto)',
        list: [
            <>
                MILANO MALPENSA <br/>
                <span style={{fontFamily:'Arial'}}>Diego Assenza – cell. 348 737 4636</span>
            </>,
            <>
                NAPOLI CAPODICHINO <br/>
                <span style={{fontFamily: 'Arial'}}>
                    Camilla Dalcerri – cell. 349 512 5100 <br/>
                    Federica Martinozzi – cell. 393 858 5032
                </span>
            </>
        ]
    },
    {
        title: 'STAFF IN LOCO',
        list: [
            <span style={{fontWeight:'normal !important', fontFamily:'Arial'}}>
                Ilaria Comiotto – cell. 347 354 7438
            </span>
        ]
    }
]
